import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

@Injectable({
    providedIn: 'root'
})
export class HtmlExcelExportService {

    public exportHtmlStringToExcel(htmlString: string, fileName: string, sheetName = 'Sheet 1'): void {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const table = doc.querySelector('table');

        if (!table) {
            console.error('No table found in the provided HTML string');
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(sheetName);

        // Iterate over table rows
        const rows = table.querySelectorAll('tr');
        rows.forEach((row) => {
            const excelRow = worksheet.addRow([]); // Add a new row to Excel
            const cells = row.querySelectorAll('th, td');
            cells.forEach((cell, cellIndex) => {
                // Set cell value
                excelRow.getCell(cellIndex + 1).value = cell.textContent?.trim() || '';

                // Apply basic styling based on HTML tags (e.g., bold for <th>)
                if (cell.tagName.toLowerCase() === 'th') {
                    excelRow.getCell(cellIndex + 1).font = { name: 'Segoe UI', family: 2, size: 14, bold: true };
                    // excelRow.getCell(cellIndex + 1).alignment = { horizontal: "justify", wrapText: true };
                    excelRow.getCell(cellIndex + 1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF157FF9' } };
                    excelRow.getCell(cellIndex + 1).protection = { locked: false, hidden: false };
                }

                if (cell.tagName.toLowerCase() === 'td') {
                    excelRow.getCell(cellIndex + 1).font = { name: 'Segoe UI', family: 2, size: 13 };
                    // excelRow.getCell(cellIndex + 1).alignment = { horizontal: "justify", wrapText: true };
                    excelRow.getCell(cellIndex + 1).protection = { locked: false, hidden: false };
                }
            });
        });

        // Write to Excel file and save it
        workbook.xlsx.writeBuffer().then((buffer: ArrayBuffer) => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, `${fileName}.xlsx`);
        }).catch(err => {
            console.error('Error during Excel file generation:', err);
        });
    }
}
